import React from "react";
import styled, { css } from "styled-components";

interface IProgressBarProps {
  percent: number;
  color?: string;
  status?: string;
  cancel?: boolean;
}

const ProgressBar = (props: IProgressBarProps) => {
  return (
    <ProgressSet color={props.color} percent={props.percent} cancel={props.cancel}>
      <div>
        <p className="status-text">{props.cancel ? "취소" : props.status}</p>
      </div>
    </ProgressSet>
  );
};

const cancelStyle = css<IProgressBarProps>`
  > div {
    background-color: #c80a3c;
    .status-text {
      color: #c80a3c;
    }
  }
`;

const ProgressSet = styled.div<IProgressBarProps>`
  margin: 20px 0 37px;
  border: 1px solid #f4f4f4;
  border-radius: 5px;
  background-color: ${(props) => (props.color === "gray" ? "#f4f5f7" : "#fff")};
  > div {
    position: relative;
    width: ${(props) => props.percent + "%" || "0%"};
    max-width: 100%;
    height: 8px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.color.main};
    color: transparent;
    font-size: 0;
    transition: width 0.5s;
    .status-text {
      position: absolute;
      top: 18px;
      right: 0;
      display: inline-block;
      min-width: 40px;
      height: 17px;
      color: #818181;
      font-size: 14px;
      ${(props) => {
        if (props.percent > 93) {
          return css`
            transform: translateX(0);
          `;
        } else if (props.percent < 6) {
          return css`
            transform: translateX(70%);
          `;
        } else {
          return css`
            transform: translateX(50%);
          `;
        }
      }};
    }
  }
  ${(props) => props.cancel && cancelStyle}
`;

export default ProgressBar;
